
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import * as emailValidator from 'email-validator';
  import {httpResource} from "@/resources/http.resource";
  import {IApp} from "@/interfaces/app.interface";

  @Component({})
  export default class FeedbackForm extends Vue {
    @Prop() popupMode!: boolean;

    formModel = {
      text: '',
      adviceFlag: true,
      email: '',
    };
    list: {
      adviceFlag: boolean;
      dateBeg: string;
      email: string;
      question: string;
      answer?: string;
    }[] = [];
    anonymousGUID = '';

    get formRules() {
      return {
        text: [{ required: true, message: ' ', trigger: 'blur' }],
        email: [{
          validator: (rule, value, callback) => emailValidator.validate(value) ? callback() : callback(new Error('Укажите email')),
          message: 'Укажите email',
          trigger: 'blur'
        }],
      }
    };

    get anonymousUser() {
      let isAnonymous = true;
      if (!!this.$store.state.auth.token && this.$store.state.auth.isUser) {
        isAnonymous = false;
      }
      return isAnonymous;
    }

    async created() {
      let storageValue = localStorage.getItem(IApp.LocalStorageKeys.FeedbackAnonymousGUID);
      this.anonymousGUID = storageValue ? storageValue : '';

      await this.getList();
    }

    async getList() {
      let asyncAction = async () => {
        let action = 'FeedBack';
        let params: any = { command: 'List', };
        if (this.anonymousUser) {
          params.guid = this.anonymousGUID;
        }
        let { data: { result: response} } = await httpResource.httpAction({ action, params });
        this.list = response.list.sort((a, b) => a.dateBeg < b.dateBeg ? 1 : -1).map(item => {
          return {
            ...item,
            question: item.question ? item.question.replaceAll('\n', '<br>') : '',
          };
        });
        if (response.guid) {
          this.anonymousGUID = response.guid;
          localStorage.setItem(IApp.LocalStorageKeys.FeedbackAnonymousGUID, this.anonymousGUID);
        }
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    sendMessage() {
      (this.$refs as any).feedbackForm.validate(async (valid) => {
        if (!valid) return;

        let asyncAction = async () => {
          let action = 'FeedBack';
          let params: any = {
            command: 'Add',
            question: this.formModel.text,
            adviceFlag: this.formModel.adviceFlag,
          };
          if (this.anonymousUser) {
            params.email = this.formModel.email;
            params.guid = this.anonymousGUID;
          }
          await httpResource.httpAction({ action, params });
        };
        let success = await this.$store.dispatch('defaultResourceAction', { asyncAction });
        if (success.success) {
          this.$notify({
            title: 'Успешно',
            message: 'Спасибо, что помогаете сделать площадку лучше',
            type: 'success'
          });

          if (this.popupMode) {
            this.$emit('sendingComplete');
          }
          else {
            await this.getList();
          }
        }
      });
    }

    async goToLogin() {
      await this.$store.dispatch('openPage', {routeName: IApp.ROUTE_NAME.PAGE_AUTHORIZATION});
    }
  }
